import React from 'react'
import VersionAuditing from './VersionAuditing'

export default function Tokens({ appVersionOptions, tokens }) {
  const columns = [
    { id: 'name', header: 'Name', cell: 'name' },
    { id: 'person', header: 'Person', cell: 'person' },
    { id: 'email', header: 'Primary Email', cell: 'email' },
    { id: 'createdAt', header: 'Created At', cell: 'created_at' },
  ]

  return (
    <VersionAuditing
      appVersionOptions={appVersionOptions}
      auditing="Personal Access Tokens"
      columns={columns}
      data={tokens}
    />
  )
}
